import { theme as mars } from '@core/themes/mars.theme';
import { theme as kepler } from '@core/themes/kepler.theme';
import { theme as roleplay } from '@core/themes/roleplay.theme';

/**
 * Registry of available visual themes, indexed by service name.
 * Consumed by ThemeService to apply the CSS variables of the active service.
 */
export const THEMES = {
  mars,
  kepler,
  roleplay
};
